import { useIsMobile } from '@/hooks/use-media-query';
import ChannelsPageDesktop from './ChannelsPageDesktop';
import MobileChannels from '@/pages/mobile/MobileChannels';

// Task #1722 — Dispatcher Channels: viewport-based.
// Mobile → `MobileChannels` (lista push → detail push, read-only per non-admin).
// Desktop → `ChannelsPageDesktop` (master-detail invariato dal monolite).
export default function ChannelsPage() {
  const isMobile = useIsMobile();
  return isMobile ? <MobileChannels /> : <ChannelsPageDesktop />;
}
